import { t } from '@lingui/core/macro';
import { useEffect } from 'react';

import { usePageContext } from './PageContext';

type PageMetadataProps = {
  children: string;
  exampleAIQuestions?: string[];
};

const PageMetadata = ({ children, exampleAIQuestions }: PageMetadataProps) => {
  const { setTitle, setExampleAIQuestions } = usePageContext();

  useEffect(() => {
    setTitle(children);

    if (children) {
      document.title = children;
    } else {
      document.title = t`Channel99`;
    }

    return () => {
      setTitle(null);
    };
  }, [children, setTitle]);

  useEffect(() => {
    if (exampleAIQuestions) {
      setExampleAIQuestions(exampleAIQuestions);
    }
  }, [exampleAIQuestions, setExampleAIQuestions]);

  return null;
};

export default PageMetadata;
